var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68042 9.38989C9.09042 8.85989 8.13046 7.66989 6.97046 6.63989C4.64046 4.10989 1.2202 1.28987 1.7102 1.11987C1.8202 0.869873 8.19011 7.54984 9.86011 9.20984C9.86011 9.20984 9.86011 9.30986 9.86011 9.35986C9.86011 9.40986 9.71042 9.41989 9.68042 9.38989Z",
    fill: "#F2F8F0",
    stroke: "white",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.84 4.35982C13.34 5.89982 11.8503 7.37988 10.3703 8.79988C10.3152 8.76577 10.2704 8.71739 10.2404 8.65987C10.2404 8.65987 10.1504 8.58986 10.2404 8.52986C10.7304 7.97986 11.86 7.08983 12.82 5.99983C15.18 3.82983 17.8204 0.609808 17.9904 1.09981C16.9404 2.17981 15.91 3.25982 14.84 4.35982Z",
    fill: "#F2F8F0",
    stroke: "white",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.f7787ac39cc442881a81aac124c3a4be.svg";
export { ForwardRef as ReactComponent };